import React from 'react';
import { CheckCircle2, AlertTriangle, XCircle, ShieldAlert } from 'lucide-react';
import { ReconciliationSummary } from '../../types/gst';

interface Props {
  summary: ReconciliationSummary;
}

export const ReconciliationKpiCards: React.FC<Props> = ({ summary }) => {
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3">
      {/* Total Purchase ITC */}
      <div className="rounded-2xl border border-white/10 bg-[#131316] p-4 text-xs space-y-1">
        <div className="text-[10px] uppercase font-bold text-slate-500">Total Purchase ITC</div>
        <div className="text-lg font-bold text-white font-mono">
          ₹{summary.totalPurchaseItc.toLocaleString('en-IN', { minimumFractionDigits: 2 })}
        </div>
        <div className="text-[10px] text-slate-400">{summary.totalPurchaseInvoices} Purchase Bills in Books</div>
      </div>

      {/* Matched in 2B (Auto-Claimed) */}
      <div className="rounded-2xl border border-emerald-500/30 bg-emerald-950/20 p-4 text-xs space-y-1">
        <div className="text-[10px] uppercase font-bold text-emerald-400 flex items-center gap-1">
          <CheckCircle2 className="h-3.5 w-3.5" />
          Matched in 2B (Auto-Claim)
        </div>
        <div className="text-lg font-bold text-emerald-300 font-mono">
          ₹{summary.matchedItc.toLocaleString('en-IN', { minimumFractionDigits: 2 })}
        </div>
        <div className="text-[10px] text-emerald-400/70">{summary.matchedCount} bills &bull; 100% Eligible</div>
      </div>

      {/* Partial Mismatches */}
      <div className="rounded-2xl border border-amber-500/30 bg-amber-950/20 p-4 text-xs space-y-1">
        <div className="text-[10px] uppercase font-bold text-amber-400 flex items-center gap-1">
          <AlertTriangle className="h-3.5 w-3.5" />
          Tax Value Mismatches
        </div>
        <div className="text-lg font-bold text-amber-300 font-mono">
          ₹{summary.partialItc.toLocaleString('en-IN', { minimumFractionDigits: 2 })}
        </div>
        <div className="text-[10px] text-amber-400/70">{summary.partialCount} bills &bull; Variance detected</div>
      </div>

      {/* Missing in 2B (Risk) */}
      <div className="rounded-2xl border border-rose-500/30 bg-rose-950/20 p-4 text-xs space-y-1">
        <div className="text-[10px] uppercase font-bold text-rose-400 flex items-center gap-1">
          <XCircle className="h-3.5 w-3.5" />
          Missing in 2B (At Risk)
        </div>
        <div className="text-lg font-bold text-rose-300 font-mono">
          ₹{summary.missingIn2bItc.toLocaleString('en-IN', { minimumFractionDigits: 2 })}
        </div>
        <div className="text-[10px] text-rose-400/70">{summary.missingIn2bCount} bills &bull; Vendor non-filing</div>
      </div>

      {/* Blocked under 17(5) */}
      <div className="rounded-2xl border border-purple-500/30 bg-purple-950/20 p-4 text-xs space-y-1">
        <div className="text-[10px] uppercase font-bold text-purple-400 flex items-center gap-1">
          <ShieldAlert className="h-3.5 w-3.5" />
          Blocked Sec 17(5)
        </div>
        <div className="text-lg font-bold text-purple-300 font-mono">
          ₹{summary.blockedItc.toLocaleString('en-IN', { minimumFractionDigits: 2 })}
        </div>
        <div className="text-[10px] text-purple-400/70">{summary.blockedCount} bills &bull; Food / Car / Gifts</div>
      </div>
    </div>
  );
};
